import { useNavigate } from 'react-router-dom'
import { KTIcon } from '../../../../../_metronic/helpers'
import useAuthorization from '../../../../../hooks/useAuthorization'

const Toolbar = () => {
    const navigate = useNavigate()
    const handleToCreate = () => navigate('/admin/rooms/create')
    const isAuthorizedToCreate = useAuthorization("admin.rooms");
    if (!isAuthorizedToCreate) return <></>

    return (
        <div className='d-flex justify-content-end' data-kt-user-table-toolbar='base'>
            <button type='button' className='btn btn-light-danger' onClick={handleToCreate}>
                <KTIcon iconName='plus' className='fs-2' />
                Adicionar Sala
            </button>
        </div>
    )
}

export { Toolbar }
